export const MIN_DRAWER_WIDTH = 192 // 12rem
export const LEFT_MINIMUM_MARGIN = 64 // 4rem
